import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const steps = [
  [FiIcons.FiMessageSquare, 'Tell Us What You Need', 'Describe the problem or service you require.'],
  [FiIcons.FiCalendar, 'Choose a Convenient Time', 'Select your preferred service date/time or request a callback.'],
  [FiIcons.FiTruck, 'We Come to You', 'An OtterWorks professional comes to your home.'],
  [FiIcons.FiCheckCircle, 'Problem Solved', 'We complete the work and leave your home ready to go.']
];

export default function HowItWorks() {
  return (
    <section className="section process-section" id="how-it-works">
      <div className="container">
        <div className="section-heading">
          <span className="eyebrow">Four simple steps</span>
          <h2>Getting Help Is Easy</h2>
        </div>
        <div className="steps">
          {steps.map(([icon, title, text], index) => (
            <article className={`step step-${index + 1}`} key={title}>
              <span className="step-number">{index + 1}</span>
              <span className="step-icon"><SafeIcon icon={icon} /></span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}